import React, { useState, useEffect } from 'react';
import "../AddClients/tableStyle.css"
import { deleteOrder, getDispatch } from '../../Services/Services';
import { Input, Button, Form, Popconfirm } from 'antd';
import AddLifterDispatch from './AddLifterDispatch';
import UpdateLifterDispatch from './UpdateLifterDispatch'
import Header from '../Header-Footer/Header';
import * as XLSX from 'xlsx'; // Import xlsx library
import { useNavigate } from 'react-router-dom';
import Footer from '../Header-Footer/Footer';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { DeleteOutlined } from '@ant-design/icons';
import { FaFilePdf, FaFileExcel } from 'react-icons/fa';
export default function LifterDispatch() {
  const navigate = useNavigate();
  const [dispatchList, setdispatchList] = useState([]);
  const [dispatchData, setdispatchData] = useState([])
  const [form] = Form.useForm();
  const handleClick = (id) => {
    const filterData = dispatchList.find(do_lis => do_lis.id === id)
    navigate('/Order-entry', { state: { data: filterData } });
  };
  useEffect(() => {
    GetDispatchList();
  }, []);

  const GetDispatchList = async () => {
    const response = await getDispatch({ 'com_name': localStorage.getItem('com_name') });
    const sortedArray = [...response].sort((a, b) => b.id - a.id);
    setdispatchList(sortedArray);
    setdispatchData(sortedArray)
  }


  const handleValuesChange = (changedValues, allValues) => {
    const filteredData = dispatchData.filter(item => 
        item.vehicle_no.toLowerCase().includes((allValues.vehicle_no || '').toLowerCase()) &&
        item.do_no.toLowerCase().includes((allValues.do_no || '').toLowerCase()) &&
      
        item.lifter_name.toLowerCase().includes((allValues.lifter_name || '').toLowerCase())
    );

    setdispatchList(filteredData);
};
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = dispatchList.map((e, index) => [
      index + 1,
      e.lifter_name,
      e.do_no,
      e.truck_owner_name,
      e.pan_no,
      e.vehicle_no,
      e.dispatch_quantity,
      e.date,
      e.advance,
      e.date,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      ['Sr. No', 'Lifter Name', 'Do No.', 'Truck Owner Name', 'Pan No', 'Vehicle No', 'Dispatch Qty', 'Dispatch Date', 'Advance Amt', 'Advance Date'],
      ...wsData,
    ]);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'dispatchList');

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, 'Dispatch List.xlsx');
  };
  const [disDetails, setdisDetails] = useState()
  const dispatch = (id) => {
    setdisDetails(dispatchList.find(o => o.id === id))
  }
  const DeleteOrder = async (id) => {
    const response = await deleteOrder(id);
    const sortedArray = [...response].sort((a, b) => b.id - a.id);
    setdispatchList(sortedArray);
    setdispatchData(sortedArray)
  }
  const formateDate =(date)=>{
    const [year, month, day] = date.split('-');
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate
  }
  
  return (
    <div style={{ height:'90vh' }}>
      <Header heading="LIFTER DISPATCH VIEW" />

      <Form
        layout="vertical"
        form={form}
        onValuesChange={handleValuesChange}
      >
        <div className=" grid grid-cols-1 sm:grid sm:grid-cols-4 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
          <Form.Item
            name="lifter_name"
            label={<b>Search Lifter Name</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Input
              placeholder='Search by Lifter Name'
            />
          </Form.Item>

          <Form.Item
            name="do_no"
            label={<b>Search DO No</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Input
              placeholder='Search by Do Number'
   
            />
          </Form.Item>
          <Form.Item
            name="vehicle_no"
            label={<b>Search Vehicle No</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Input
              placeholder='Search by Vehicle Number'

            />
          </Form.Item>
          <Form.Item>
            <br></br>
            {localStorage.getItem('user_type') === 'Lifter' &&
              <>
                <AddLifterDispatch setdispatchList={setdispatchList} setdispatchData={setdispatchData} />
              </>
            }
            <Button
              style={{
                bottom:'-5px',
                margin: "10px",
                backgroundColor: 'black',
                color: 'white',
                fontWeight: '600'
              }}
              onClick={handlePrint}
            >
              <FaFilePdf/>
            </Button>
            <Button onClick={handleExportToExcel} style={{ backgroundColor: 'green', color: 'white', marginLeft: '10px' ,bottom:'-5px' }}><FaFileExcel/></Button>

          </Form.Item>
        </div>


      </Form>
      <div className="table-wrapper" ref={componentRef} style={{ maxHeight: "480px", overflowX: "auto", overflowY: "auto" }}>
        <table id="my-table" className="w-full">
          <thead className="bg-[#151B54] w-full text-white" >
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Sr. No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Id</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Lifter Name</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">Do Number</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Truck Owner Name</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Pan No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Vehicle No</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Dispatch Qty</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Dispatch Date</th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Advance Amt</th>
            
              {localStorage.getItem('user_type') !== 'Lifter' &&
                <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Order Entry</th>
              }
              {localStorage.getItem('user_type') === 'Lifter' &&
                <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Update</th>
              }
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">Delete</th>
            </tr>
          </thead>
          <tbody>
            {dispatchList.map((e, index) => (
              <tr >
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{index + 1}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.id}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.lifter_name}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.do_no}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.truck_owner_name}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.pan_no}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.vehicle_no}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{(e.dispatch_quantity).toFixed(3)}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{formateDate(e.date)}</td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">{e.advance}</td>
              
                {localStorage.getItem('user_type') !== 'Lifter' &&
                  <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base"><buttpn onClick={() => handleClick(e.id)} ><u style={{ color: "blue", fontWeight: '500', fontSize: "15px" }}>click</u></buttpn></td>
                }
                {localStorage.getItem('user_type') === 'Lifter' && <td>
                  <button onClick={() => dispatch(e.id)}>
                    <UpdateLifterDispatch setdispatchList={setdispatchList} setdispatchData={setdispatchData} disDetails={disDetails} />
                  </button>
                </td>
                }
                <td>
             
                  <Popconfirm
                    title="Delete the task"
                    description="Are you sure to delete this dispatch?"
                    okText={<span style={{color:"black"}}> Yes</span>}
                    cancelText="No"
                    onConfirm={() => DeleteOrder(e.id)}
                  >
                    <button >

                      <DeleteOutlined
                        style={{
                          color: 'red',
                          fontSize: "13px",
                        }}
                      />
                    </button>
                  </Popconfirm>
                </td>

              </tr>

            ))}
            <tr style={{ backgroundColor: '#e9e9e9' }}>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base" colSpan={7}><b>Total</b></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{dispatchList.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.dispatch_quantity),
                  0
                ).toFixed(3)}</b></td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">

              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                <b>{dispatchList.reduce(
                  (accumulator, currentValue) =>
                    accumulator + (+currentValue.advance),
                  0
                ).toFixed(3)}</b>
              </td>
              <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base" colSpan={2}></td>
            </tr>
          </tbody>
        </table>
      </div>
      {/* <Footer /> */}
    </div>
  )
}
